import styled from 'styled-components';

import ToolIconHolderTitle from './ToolIconHolderTitle';

export default styled.div`
  display: ${props => props.thisStyles && props.thisStyles.display ? props.thisStyles.display : 'flex'};
  align-items: center;
  justify-content: center;
  position: ${props => props.thisStyles && props.thisStyles.position ? props.thisStyles.position : 'relative'};
  width: ${props => props.thisStyles && props.thisStyles.width ? props.thisStyles.width : ''};
  height: ${props => props.thisStyles && props.thisStyles.height ? props.thisStyles.height : '100%'};
  left: ${props => props.thisStyles && props.thisStyles.left ? props.thisStyles.left : ''};
  right: ${props => props.thisStyles && props.thisStyles.right ? props.thisStyles.right : ''};
  top: ${props => props.thisStyles && props.thisStyles.top ? props.thisStyles.top : ''};
  margin: ${props => props.thisStyles && props.thisStyles.margin ? props.thisStyles.margin : ''};
  padding: ${props => props.thisStyles && props.thisStyles.padding ? props.thisStyles.padding : '0'};
  float: ${props => props.thisStyles && props.thisStyles.float ? props.thisStyles.float : ''};
  background: ${props => props.thisStyles && props.thisStyles.background ? props.thisStyles.background : 'none'};
  border-radius: ${props => props.thisStyles && props.thisStyles.borderRadius ? props.thisStyles.borderRadius : '0'};

  &:hover {
    background: ${props => props.thisStyles && props.thisStyles.backgroundHover ? props.thisStyles.backgroundHover : 'none'};

    ${props => props.thisStylesHover}

    svg  {
      stroke: ${props => props.thisStyles && props.thisStyles.hoverIconStroke ? props => props.thisStyles && props.thisStyles.hoverIconStroke : ''};
      fill: ${props => props.thisStyles && props.thisStyles.hoverIconFill ? props => props.thisStyles && props.thisStyles.hoverIconFill : ''};
    }

    svg path {
      stroke: ${props => props.thisStyles && props.thisStyles.hoverIconStroke ? props => props.thisStyles && props.thisStyles.hoverIconStroke : ''};
      fill: ${props => props.thisStyles && props.thisStyles.hoverIconFill ? props => props.thisStyles && props.thisStyles.hoverIconFill : ''};
    }

    svg rect {
      stroke: ${props => props.thisStyles && props.thisStyles.hoverIconStroke ? props => props.thisStyles && props.thisStyles.hoverIconStroke : ''};
      fill: ${props => props.thisStyles && props.thisStyles.hoverIconFill ? props => props.thisStyles && props.thisStyles.hoverIconFill : ''};
    }

    svg circle {
      stroke: ${props => props.thisStyles && props.thisStyles.hoverIconStroke ? props => props.thisStyles && props.thisStyles.hoverIconStroke : ''};
      fill: ${props => props.thisStyles && props.thisStyles.hoverIconFill ? props => props.thisStyles && props.thisStyles.hoverIconFill : ''};
    }

    svg line {
      stroke: ${props => props.thisStyles && props.thisStyles.hoverIconStroke ? props => props.thisStyles && props.thisStyles.hoverIconStroke : ''};
      fill: ${props => props.thisStyles && props.thisStyles.hoverIconFill ? props => props.thisStyles && props.thisStyles.hoverIconFill : ''};
    }
  }

  svg {
    stroke: ${props => props.thisStyles && props.thisStyles.iconStroke ? props => props.thisStyles && props.thisStyles.iconStroke : ''};
    stroke-width: ${props => props.thisStyles && props.thisStyles.iconStrokeWidth ? props.thisStyles.iconStrokeWidth : '1px'};
    stroke-linecap: round;
    stroke-linejoin: round;
    fill: none;
  }

  svg path {
    stroke: ${props => props.thisStyles && props.thisStyles.iconStroke ? props => props.thisStyles && props.thisStyles.iconStroke : ''};
    fill: ${props => props.thisStyles && props.thisStyles.iconFill ? props => props.thisStyles && props.thisStyles.iconFill : ''};
    stroke-width: ${props => props.thisStyles && props.thisStyles.iconStrokeWidth ? props.thisStyles.iconStrokeWidth : '1px'};
  }

  svg rect {
    stroke: ${props => props.thisStyles && props.thisStyles.iconStroke ? props => props.thisStyles && props.thisStyles.iconStroke : ''};
    fill: ${props => props.thisStyles && props.thisStyles.iconFill ? props => props.thisStyles && props.thisStyles.iconFill : ''};
    stroke-width: ${props => props.thisStyles && props.thisStyles.iconStrokeWidth ? props.thisStyles.iconStrokeWidth : '1px'};
  }

  svg circle {
    stroke: ${props => props.thisStyles && props.thisStyles.iconStroke ? props => props.thisStyles && props.thisStyles.iconStroke : ''};
    fill: ${props => props.thisStyles && props.thisStyles.iconFill ? props => props.thisStyles && props.thisStyles.iconFill : ''};
    stroke-width: ${props => props.thisStyles && props.thisStyles.iconStrokeWidth ? props.thisStyles.iconStrokeWidth : '1px'};
  }

  svg line {
    stroke: ${props => props.thisStyles && props.thisStyles.iconStroke ? props => props.thisStyles && props.thisStyles.iconStroke : ''};
    fill: ${props => props.thisStyles && props.thisStyles.iconFill ? props => props.thisStyles && props.thisStyles.iconFill : ''};
    stroke-width: ${props => props.thisStyles && props.thisStyles.iconStrokeWidth ? props.thisStyles.iconStrokeWidth : '1px'};
  }

  & ${ToolIconHolderTitle} {
    color: ${props => props.thisStyles && props.thisStyles.textColor ? props.thisStyles.textColor : props.thisStyles.iconStroke};
  }

  &:hover ${ToolIconHolderTitle} {
    color: ${props => props.thisStyles && props.thisStyles.textHoverColor ? props.thisStyles.textHoverColor : props.thisStyles.hoverIconStroke};
  }

  ${props => props.thisStyles}
`;
